import FormData from 'form-data';
import { put } from 'redux-saga/effects';
import { apiImageUpload, apiPost } from 'shared/api';
import * as actions from 'store/actions';
import { fetchUserProfile } from 'store/thunks';

export function* uploadProfileImageSaga(action) {
  yield put(actions.uploadProfileImageStart());
  try {
    const imageFormData = new FormData();
    yield imageFormData.append('Image', action.profileImage);
    const response = yield apiImageUpload('userFileUpload', imageFormData);
    const profileImageResponse = yield response.data.payload.Files[0];
    yield put(actions.setProfileImage(profileImageResponse.Id, profileImageResponse.FileURL, profileImageResponse.ThumbURL));
  } catch (error) {
    yield put(actions.uploadProfileImageFailed(error.response.data.error_message));
  }
}

// submitProfileSaga => submitProfile

// fetchUserProfileSaga => fetchUserProfile

export function* updateEmailSaga(action) {
  yield put(actions.updateEmailStart());
  try {
    const response = yield apiPost('v2_userProfileUpdate', { Email: action.Email });
    const email = yield response.data.payload.User.Email;
    yield put(actions.updateEmailSuccess(email));
  } catch (error) {
    yield put(actions.updateEmailFailed(error.response.data.error_message));
  }
}

export function* updatePasswordSaga(action) {
  yield put(actions.updatePasswordStart());
  try {
    yield apiPost('v2_userProfileUpdate', { Password: action.NewPassword, OldPassword: action.OldPassword });
    yield put(actions.updatePasswordSuccess());
  } catch (error) {
    yield put(actions.updatePasswordFailed(error.response.data.error_message));
  }
}

export function* deleteManagedAccountSaga(action) {
  yield put(actions.deleteManagedAccountStart());
  try {
    const response = yield apiPost('v2_userProfileUpdate', { ManageUserId: action.UserId, Delete: 'true' });
    yield put(actions.deleteManagedAccountSuccess(response.data.payload.UserId));
    yield put(fetchUserProfile(false, action.UserId, 'signedInAs', true));
  } catch (error) {
    yield put(actions.deleteManagedAccountFailed(error.response.data.error_message));
  }
}

export function* userSearchSaga(action) {
  yield put(actions.userSearchStart());
  try {
    const response = yield apiPost('userSearch', { SearchFor: action.SearchFor });
    yield put(actions.userSearchSuccess(response.data.payload.Users));
  } catch (error) {
    yield put(actions.userSearchFailed(error.response.data.error_message));
  }
}
